import { MARKETING_HUB_ENTERPRISE, MARKETING_HUB_PROFESSIONAL, MARKETING_HUB_STARTER, SALES_HUB_ENTERPRISE, SALES_HUB_PROFESSIONAL, SALES_HUB_STARTER, SERVICE_HUB_ENTERPRISE, SERVICE_HUB_PROFESSIONAL, SERVICE_HUB_STARTER } from 'self-service-api/constants/ApiNames';
import { CONTACT, MARKETING_CONTACT_DEPRECATED, USER } from 'self-service-api/constants/UnitTypes';
import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';
const QuantityPackToUpgradeProduct = {
  [MARKETING_HUB_STARTER]: {
    [CONTACT]: UpgradeProducts.MARKETING_STARTER_CONTACTS,
    [MARKETING_CONTACT_DEPRECATED]: UpgradeProducts.MARKETING_STARTER_CONTACTS
  },
  [MARKETING_HUB_PROFESSIONAL]: {
    [CONTACT]: UpgradeProducts.MARKETING_PROFESSIONAL_CONTACTS,
    [MARKETING_CONTACT_DEPRECATED]: UpgradeProducts.MARKETING_PROFESSIONAL_CONTACTS
  },
  [MARKETING_HUB_ENTERPRISE]: {
    [CONTACT]: UpgradeProducts.MARKETING_ENTERPRISE_CONTACTS,
    [MARKETING_CONTACT_DEPRECATED]: UpgradeProducts.MARKETING_ENTERPRISE_CONTACTS
  },
  [SALES_HUB_STARTER]: {
    [USER]: UpgradeProducts.SALES_STARTER_USER
  },
  [SALES_HUB_PROFESSIONAL]: {
    [USER]: UpgradeProducts.SALES_PROFESSIONAL_USER
  },
  [SALES_HUB_ENTERPRISE]: {
    [USER]: UpgradeProducts.SALES_ENTERPRISE_USER
  },
  [SERVICE_HUB_STARTER]: {
    [USER]: UpgradeProducts.SERVICE_STARTER_USER
  },
  [SERVICE_HUB_PROFESSIONAL]: {
    [USER]: UpgradeProducts.SERVICE_PROFESSIONAL_USER
  },
  [SERVICE_HUB_ENTERPRISE]: {
    [USER]: UpgradeProducts.SERVICE_ENTERPRISE_USER
  }
};
export default QuantityPackToUpgradeProduct;